export default "__VITE_ASSET__CWxDUS5z__"